var exports = {
  "D": "x804f0401--e2803c--title",
  "O": "x804f0401--e2803c--rating",
};

module.exports = exports;
